import { IconProps } from ".";
export const GlobeNetworkIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M11.3064 20.9896C6.66868 20.6149 3.0332 16.7362 3.0332 12.004C3.0332 7.03834 7.06181 3 12.0372 3C16.638 3 20.4224 6.44864 20.9663 10.8986"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1751 8.87456C14.706 5.44538 13.4789 3 12.0359 3C10.6025 3 9.36573 5.44538 8.89767 8.87456C8.75657 9.84863 8.68164 10.8976 8.68164 12.004C8.68164 13.1095 8.75657 14.1682 8.89767 15.1423C9.2256 17.5224 10.2376 19.818 11.3051 20.9886"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.0332 12.0117H10.4675"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5142 14.8224L18.6152 15.0958C18.9961 16.1266 19.8076 16.9393 20.837 17.3207L21.1099 17.4219L20.837 17.523C19.8076 17.9045 18.9961 18.7172 18.6152 19.748L18.5142 20.0214L18.4132 19.748C18.0323 18.7172 17.2208 17.9045 16.1915 17.523L15.9185 17.4219L16.1915 17.3207C17.2208 16.9393 18.0323 16.1266 18.4132 15.0958L18.5142 14.8224Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2033 13.5803C13.3749 14.145 13.8162 14.5869 14.38 14.7588C13.8162 14.9306 13.3749 15.3726 13.2033 15.9372C13.0317 15.3726 12.5904 14.9306 12.0266 14.7588C12.5904 14.5869 13.0317 14.145 13.2033 13.5803Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
